// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import {
  getAuth,
  sendSignInLinkToEmail,
  isSignInWithEmailLink,
  signInWithEmailLink,
  sendEmailVerification,
  onAuthStateChanged,
  signOut,
  updateProfile,
} from 'firebase/auth';
import {
  getDatabase,
  ref,
  set,
  get,
  child,
  update,
  onValue,
} from 'firebase/database';
import {
  getStorage,
  ref as storageRef,
  getDownloadURL,
  uploadBytesResumable,
} from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyCGbMXMCJz_k1SLYeb2jkh1n8AR7KAhsoE',
  authDomain: 'sweet-be7c5.firebaseapp.com',
  projectId: 'sweet-be7c5',
  storageBucket: 'sweet-be7c5.appspot.com',
  messagingSenderId: '686933780116',
  appId: '1:686933780116:web:f50dea304f43316b7a7681',
  databaseURL:
    'https://sweet-be7c5-default-rtdb.asia-southeast1.firebasedatabase.app/',
};

initializeApp(firebaseConfig);
const auth = getAuth();
const databaseInstance = getDatabase();
const storageInstance = getStorage();

const actionCodeSettings = {
  url: 'https://supinkim.github.io/sweet/',
  handleCodeInApp: true,
};

export {
  auth,
  sendSignInLinkToEmail,
  actionCodeSettings,
  isSignInWithEmailLink,
  signInWithEmailLink,
  sendEmailVerification,
  onAuthStateChanged,
  signOut,
  updateProfile,
  databaseInstance,
  ref,
  set,
  get,
  child,
  update,
  onValue,
  storageInstance,
  storageRef,
  uploadBytesResumable,
  getDownloadURL,
};
